// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Table, Button, Row, FormGroup, FormControl, Checkbox } from 'react-bootstrap'
import { AlertMessage } from '../components/alertMessage'
import config from '../config/config.json'

export class AssignTrainingModules extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedModules: [],
            assignmentExistsErrors: 0,
            assignmentSuccessful: 0,
            assignmentFailedErrors: 0,
            searchString: '',
            categoryFilter: 'All',
            selectAllModules: false
        }

        this.handleBackToSelectWorkers = this.handleBackToSelectWorkers.bind(this)
        this.handleSelectModulesClick = this.handleSelectModulesClick.bind(this)
        this.selectModules = this.selectModules.bind(this)
        this.deselectModules = this.deselectModules.bind(this)
        this.loadSelectedWorkers = this.loadSelectedWorkers.bind(this)
        this.handleConfirmAssignmentClick = this.handleConfirmAssignmentClick.bind(this)
        this.assignModules = this.assignModules.bind(this)
        this.loadAssignmentSuccessfulAlert = this.loadAssignmentSuccessfulAlert.bind(this)
        this.loadAssignmentExistsErrorsAlert = this.loadAssignmentExistsErrorsAlert.bind(this)
        this.loadAssignmentFailureErrorsAlert = this.loadAssignmentFailureErrorsAlert.bind(this)
        this.loadModules = this.loadModules.bind(this)
        this.onChangeNumOf = this.onChangeNumOf.bind(this)
        this.onChangeDayType = this.onChangeDayType.bind(this)
        this.searchModules = this.searchModules.bind(this)
        this.handleSelectAllModules = this.handleSelectAllModules.bind(this)
        this.filterCategory = this.filterCategory.bind(this)
    }

    handleOnSelectModulesFinal(e) {
        e.preventDefault()
        this.props.handleSelectedWorkersFinal(this.state.selectedWorkers)
    }

    handleSelectAllModules(e) {
        let modulesList = this.props.modules.filter(module => {
            if (!this.checkLicenceCount(module.licence_count))
                return false

            if (this.state.categoryFilter === "All")
                return true
            else {
                return (module.category.indexOf(this.state.categoryFilter) > -1)
            }
        })

        modulesList = modulesList.filter(module => {
            return ((module.name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1)
        })

        if (e.target.checked) {
            this.setState({
                selectAllModules: e.target.checked,
                selectedModules: modulesList
            })

        }
        else {
            this.setState({
                selectAllModules: e.target.checked,
                selectedModules: []
            })
        }
    }

    handleSelectModulesClick(e) {
        //console.log((e.target.checked ? "Selected module: " : "Deselected module: "), e.target)

        if (e.target.checked) {
            this.selectModules(e.target.getAttribute("data-moduleId"), e.target.getAttribute("data-moduleName"))
            e.target.checked = true
        }
        else {
            this.deselectModules(e.target.getAttribute("data-moduleId"))
            e.target.checked = false
        }
    }

    selectModules(id, name) {
        let selectedModules = this.state.selectedModules
        selectedModules.push({
            id,
            name
        })
        this.setState({
            selectAllModules: false,
            selectedModules
        })
    }

    deselectModules(id) {
        let selectedModules = this.state.selectedModules.filter(module => {
            return module.id !== id
        })
        this.setState({
            selectAllModules: false,
            selectedModules
        })
    }

    handleBackToSelectWorkers(e) {
        e.preventDefault()

        this.props.router.push('/assignTraining/individuals')
    }

    handleConfirmAssignmentClick(e) {
        let env = this.props.env
        let selectedModules = this.state.selectedModules

        this.setState({
            assignmentExistsErrors: 0,
            assignmentSuccessful: 0,
            assignmentFailedErrors: 0
        })
        this.props.selectedWorkersFinal.forEach(worker => {
            selectedModules.forEach(module => {
                let numOf = document.getElementById("numOf" + module.id).value
                let dayType = document.getElementById("dayType" + module.id).value
                let totalDays = numOf * dayType
                //console.log(`Assign module ${module.id} to worker ${worker.id} for ${totalDays} days`)
                this.assignModules(env, config, worker.id, module.id, totalDays)
            })
        })

        // On pages with lots of workers, the user may not scroll up to see feedback message, so force scroll to top
        window.scrollTo(0, 0)
    }

    assignModules(env, config, workerId, moduleId, duration = null, frequency = 1) {
        //console.log(this.props.appData.authToken||window.sessionStorage.authToken)

        fetch(config[env] + config.api.add_assignment.endpoint, {
            method: config.api.add_assignment.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            },
            body: JSON.stringify({
                assignment: {
                    worker_id: workerId,
                    enabler_module_id: moduleId,
                    duration: duration,
                    frequency: frequency
                }
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                if ('errors' in responseJson) {
                    //console.log(errorMessage)
                    if (responseJson.errors.base[0].includes("already exists")) {
                        this.setState((prevState, props) => {
                            return {
                                assignmentExistsErrors: prevState.assignmentExistsErrors + 1
                            }
                        })
                    }
                    else {
                        this.setState((prevState, props) => {
                            return {
                                assignmentFailureErrors: prevState.assignmentFailureErrors + 1
                            }
                        })
                    }
                }
                else {
                    this.setState((prevState, props) => {
                        return {
                            assignmentSuccessful: prevState.assignmentSuccessful + 1
                        }
                    })
                    this.props.getProviderModules(this.props.env, config)
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    loadAssignmentSuccessfulAlert() {
        if (this.state.assignmentSuccessful > 0) {
            return (
                <AlertMessage
                    status="success"
                    message={this.state.assignmentSuccessful + " new assignments sucessfully created."}
                >
                </AlertMessage>
            )
        }
    }

    loadAssignmentExistsErrorsAlert() {
        if (this.state.assignmentExistsErrors > 0) {
            return (
                <AlertMessage
                    status="warning"
                    message={this.state.assignmentExistsErrors + " assignments already exist."}
                >
                </AlertMessage>
            )
        }
    }

    loadAssignmentFailureErrorsAlert() {
        if (this.state.assignmentFailureErrors > 0) {
            return (
                <AlertMessage
                    status="danger"
                    message={this.state.assignmentFailureErrors + " assignments failed (possible insufficient licences)."}
                >
                </AlertMessage>
            )
        }
    }

    prepareCategoriesDisplay(categories = []) {
        return categories.map((category, index) => {
            if (index !== categories.length - 1) {
                return (
                    <div key={index}>
                        <span>{category}</span>,
                    </div>
                )
            } else {
                return (
                    <div key={index}>
                        <span>{category}</span>
                    </div>
                )
            }
        })
    }

    checkLicenceCount(licenceCount) {
        return (licenceCount >= this.props.selectedWorkersFinal.length)
    }

    onChangeNumOf(e) {
        if (e.target.value < 0) {
            e.target.value = 0
        }
        if (e.target.value - Math.floor(e.target.value) > 0) {
            e.target.value = Math.floor(e.target.value)
        }

        let dayType = document.getElementById('dayType' + e.target.getAttribute('data-index')).value
        document.getElementById('completionDate' + e.target.getAttribute('data-index')).innerHTML = this.evalCompletionDate(e.target.value * dayType)
    }

    onChangeDayType(e) {
        let numOf = document.getElementById('numOf' + e.target.getAttribute('data-index')).value
        document.getElementById('completionDate' + e.target.getAttribute('data-index')).innerHTML = this.evalCompletionDate(e.target.value * numOf)
    }

    evalCompletionDate(daysToAdd) {
        let currentDate = new Date(new Date().getTime() + daysToAdd * 24 * 60 * 60 * 1000);
        let day = currentDate.getDate()
        let month = currentDate.getMonth() + 1
        let year = currentDate.getFullYear()

        return (day + "/" + month + "/" + year)
    }

    searchModules(e) {
        this.setState({
            searchString: e.target.value
        })
    }

    shouldBeSelected(wasSelected, selectAll, licenceCount) {
        if (!this.checkLicenceCount(licenceCount)) {
            return false
        }

        return (wasSelected || selectAll)
    }

    filterCategory(e) {
        this.setState({
            categoryFilter: e.target.value
        })
    }

    get records() {
        let modulesList = this.props.modules.filter(module => {
            if (this.state.categoryFilter === "All")
                return true
            else {
                return (module.category.indexOf(this.state.categoryFilter) > -1)
            }
        })

        modulesList.sort((a, b) => (a.name < b.name) ? -1 : 1)

        modulesList = modulesList.filter(module => {
            return ((module.name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1)
        })

        return modulesList.map((module, index) => {
            let wasSelected = false
            let selectAll = this.state.selectAllModules

            this.state.selectedModules.forEach(selectedModule => {
                if (module.id === Number(selectedModule.id)) {
                    wasSelected = true
                }
            })

            return (
                <tr key={index}>
                    <td>
                        <FormGroup>
                            <Checkbox inline id={module.id} onChange={this.handleSelectModulesClick} data-moduleId={module.id} data-moduleName={module.name} disabled={!this.checkLicenceCount(module.licence_count)} checked={this.shouldBeSelected(wasSelected, selectAll, module.licence_count)}></Checkbox>
                        </FormGroup>
                    </td>
                    <td>
                        <label>{module.name}</label>
                        <div>Available: {module.licence_count}</div>
                        <div id={"errorText" + module.id} className="licenceCountErrorContainer">{this.checkLicenceCount(module.licence_count) ? "" : "Not enough licences"}</div>
                    </td>
                    <td>
                        <form>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <FormControl type="number" defaultValue={1} id={"numOf" + module.id} data-index={module.id} onChange={this.onChangeNumOf} />
                                        </td>
                                        <td>
                                            <FormControl componentClass="select" placeholder="select" id={"dayType" + module.id} data-index={module.id} onChange={this.onChangeDayType}>
                                                <option value={30}>Months</option>
                                                <option value={7}>Weeks</option>
                                                <option value={1}>Days</option>
                                                <option value={365}>Years</option>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <div className="completion-date">Complete By: <span id={"completionDate" + module.id}>{this.evalCompletionDate(30)}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </td>
                </tr>
            )
        })
    }

    loadSelectedWorkers() {
        let selectedWorkers = this.props.selectedWorkersFinal

        return (
            selectedWorkers.map((worker, index) => {
                if (index !== selectedWorkers.length - 1) {
                    return (
                        <span key={index}>{worker.name}{", "}</span>
                    )
                }
                else {
                    return (
                        <span key={index}>{worker.name}</span>
                    )
                }
            })
        )
    }

    loadModules() {
        return (
            <section className="module-listing">
                <Row style={{ display: 'block' }}>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <h4>
                            <div className="selected-workers">You have selected <label>{this.props.selectedWorkersFinal.length}</label> Individuals</div>
                        </h4>
                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                        <Table responsive bsClass="table">
                            <thead>
                                <tr>
                                    <th>Select Module</th>
                                    <th>Module Name</th>
                                    <th colSpan="2">Assessment Period</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <form id="selectAll">
                                            <FormGroup>
                                                <Checkbox checked={this.state.selectAllModules} onChange={this.handleSelectAllModules}>Select All</Checkbox>
                                            </FormGroup>
                                        </form>
                                    </td>
                                    <td>
                                        <form id="search">
                                            <FormGroup controlId="formSearchString">
                                                <FormControl type="text" placeholder="Search Modules" onChange={this.searchModules} />
                                            </FormGroup>
                                        </form>
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                                {this.records}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={3} smOffset={1} sm={3} mdOffset={1} md={3}>
                        <Button bsStyle='primary' onClick={this.handleBackToSelectWorkers}>Step 1: Select Workers</Button>
                    </Col>
                    <Col xsOffset={4} xs={3} smOffset={4} sm={3} mdOffset={4} md={3}>
                        <Button bsStyle='primary' disabled={this.state.selectedModules.length === 0} onClick={this.handleConfirmAssignmentClick}>Confirm</Button>
                    </Col>
                </Row>
            </section>
        )
    }

    prepareBreadCrumb() {
        return (<div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>)
    }

    render() {
        return (
            <section className="assign-modules" >
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {this.prepareBreadCrumb()}
                            <h2 className="title">Assign Training</h2>
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        {this.loadAssignmentSuccessfulAlert()}
                        {this.loadAssignmentExistsErrorsAlert()}
                        {this.loadAssignmentFailureErrorsAlert()}
                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <h3>
                            Step 2: Select Modules
                        </h3>
                    </Col>
                </Row>
                {this.loadModules()}
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/assignTrainingModules.js